var _defs, _g, _path, _g2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermPi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#04c;}.c{fill:#fb8;}.d{opacity:.15;}.e{opacity:.35;}.f{fill:#05f;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 216.76,
    cy: 223.41,
    rx: 39.89,
    ry: 59.83
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.32,292.98c-22.69,0-43.69-12.87-54.07-32.95-10.83-.97-19.06-9.41-19.06-19.65,0-7.94,4.86-14.92,12.32-18.05v-6.59c0-33.53,27.28-60.81,60.81-60.81s60.81,27.28,60.81,60.81v6.59c7.46,3.13,12.32,10.11,12.32,18.05,0,10.35-8.42,18.87-19.08,19.69-10.37,20.06-31.36,32.91-54.05,32.91Zm0-131.4c-29.86,0-54.16,24.3-54.16,54.16v11.44l-2.4,.69c-5.93,1.71-9.92,6.74-9.92,12.51,0,7.23,6.34,13.1,14.13,13.1h2.1l1.3,1.89c8.93,18.81,28.14,30.96,48.95,30.96s40.03-12.15,48.95-30.96l.9-1.9h2.11c8.18,0,14.51-5.88,14.51-13.1,0-5.77-3.99-10.8-9.92-12.51l-2.4-.69v-11.44c0-29.86-24.3-54.16-54.16-54.16Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M387.62,332.71c-27.98,24.22-64.47,38.87-104.38,38.87-88.12,0-159.56-71.44-159.56-159.56,0-29.48,8-57.1,21.94-80.8-33.8,29.25-55.18,72.47-55.18,120.68,0,88.12,71.43,159.56,159.56,159.56,58.64,0,109.89-31.63,137.62-78.76Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.63,369.67c-.14,0-.29,0-.43-.03-1.82-.23-3.1-1.9-2.87-3.72l3.32-25.59c2.23-13.34,9.58-24.72,20.7-32.18,11.13-7.46,24.43-9.92,37.5-6.95l34.89,7.95c9.15,2.08,18.82,2.1,27.96,.02l35.4-8.01c13.2-2.99,26.7-.55,38.03,6.87,11.32,7.41,18.95,18.81,21.5,32.1l3.34,20.89c.29,1.81-.94,3.52-2.76,3.81-1.83,.3-3.52-.95-3.81-2.76l-3.32-20.8c-2.18-11.4-8.79-21.27-18.59-27.69-9.8-6.41-21.5-8.52-32.92-5.94l-35.4,8.01c-10.11,2.29-20.79,2.28-30.9-.03l-34.89-7.95c-11.27-2.55-22.73-.44-32.32,5.99-9.6,6.43-15.93,16.24-17.83,27.63l-3.31,25.47c-.22,1.68-1.65,2.9-3.29,2.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250,412.88c-89.81,0-162.88-73.07-162.88-162.88S160.19,87.12,250,87.12s162.88,73.07,162.88,162.88-73.07,162.88-162.88,162.88Zm0-319.11c-86.15,0-156.23,70.09-156.23,156.23s70.09,156.23,156.23,156.23,156.23-70.09,156.23-156.23S336.15,93.77,250,93.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermPi);
export default __webpack_public_path__ + "static/media/term_pi.c871a8f05263fab0d4d00b09f86d1f78.svg";
export { ForwardRef as ReactComponent };